import AccountDisabled from './AccountDisabled';

export default AccountDisabled;
